<template>
  <div class="basket-box-modal-review">
    <DefImg :result="result?.picture" />
    <DefPrice>
      {{ result?.price?.printPrice }}
    </DefPrice>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPrice from '../../../Def/DefPrice/DefPrice';

export default {
  name: 'BasketBoxModalReview',
  components: {
    DefImg,
    DefPrice,
  },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.basket-box-modal-review {
  display: flex;
  flex-direction: column;
  padding: 8px;
  :deep(.def-img) {
    margin-bottom: 8px;
  }
  :deep(.def-price) {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-align: center;
  }
}
</style>
